import { render, staticRenderFns, recyclableRender, components } from "./app-share.vue?vue&type=template&id=4fc455f0&scoped=true&"
var renderjs
import script from "./app-share.vue?vue&type=script&lang=js&"
export * from "./app-share.vue?vue&type=script&lang=js&"
import style0 from "./app-share.vue?vue&type=style&index=0&id=4fc455f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc455f0",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/app-share.vue"
export default component.exports